import { Spin, Card, Carousel, Col, Form, Image, Input, Pagination, Row, Space, Table, Tabs, Button, Typography, Tree, Tooltip } from "antd";
import { DeleteOutlined, UploadOutlined, LoadingOutlined, InfoCircleFilled, FilePdfOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import i18next from "i18next";
import { useDispatch, useSelector } from 'react-redux';



import FeatureToolbarComponent from "../sgvmap/widgets/feature/FeatureToolbarComponent";
import { EdrService } from "../../service/cartoService";
import ColumnGroup from "antd/es/table/ColumnGroup";
import Column from "antd/es/table/Column";
import VicaEDARAutocontroles from "./VicaEDARAutocontroles";

import { login, logout, user_state } from "../../features/user/userSlice";

import ModalDelete from "./ModalDelete";
import ModalUpload from "./ModalUpload";
import { ServicesConfig } from "../../service/servicesConfig";


const { DirectoryTree } = Tree;

const { Title, Text } = Typography;

const VicaEDARGestIAA = ({ results, mapView, table, mapLayer, sublayer, currentTabsResult, setCurrenTabsResult }) => {
    const [result, setResult] = useState(results[0]);
    const [current, setCurrent] = useState(1);

    const onChangePagination = (page) => {
        setCurrent(page);
        setResult(results[page - 1]);
        let copy = Object.assign({}, currentTabsResult);
        copy[mapLayer.name + ": " + sublayer.title] = results[page - 1];
        setCurrenTabsResult(copy);
    };

    return (
        <>
            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}
            <Row justify="end" style={{ paddingBottom: "10px", paddingTop: "5px" }}>
                <FeatureToolbarComponent mapView={mapView} table={table} mapLayer={mapLayer} sublayer={sublayer} feature={result.feature}></FeatureToolbarComponent>
            </Row>
            <div>
                <Content result={result}></Content>
            </div>

            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}

        </>
    )
};
export default VicaEDARGestIAA;

const Content = ({ result }) => {

    const [edr, setEdr] = useState({ datosContructivos: { edrDatosWebPK: {} }, datosAnterior: { edrDatosWebPK: {} }, datosNucleos: [] });
    const [añosFichasAnuales, setAñosFichasAnuales] = useState([]);

    useEffect(() => {
        //console.log('findedar entidad')
        EdrService.findEdarEntidades(result.feature.attributes.CODEDAR)
            .then((data) => {
                setEdr(data);
            })
            .catch(err => {
                if (err?.response?.json) {
                    err.response.json().then(res => {
                        console.log("ERROR", res);
                    }).catch(() => console.error(err));
                } else {
                    console.error(err);
                }
            })
    }, [result])

    useEffect(() => {
        EdrService.getFichasAnualesAnos(result.feature.attributes.CODEDAR)
            .then((res) => {
                const annos = Array.isArray(res) ? res : (res && res.anos) || [];
                setAñosFichasAnuales(annos);
            })
            .catch(() => {
                setAñosFichasAnuales([]);
            });
    }, [result.feature.attributes.CODEDAR]);

    const tabItems = [
        {
            label: 'Datos constructivos',
            key: 'tab_1',
            children: <ContentDatosConstructivos result={result} edr={edr}></ContentDatosConstructivos>,
        },
        {
            label: 'Datos anuales',
            key: 'tab_2',
            children: <ContentDatosAnuales result={result} edr={edr}></ContentDatosAnuales>,
        },
        {
            label: 'Fotos',
            key: 'tab_3',
            children: <ContentFotos result={result} codedar={result.feature.attributes.CODEDAR}></ContentFotos>,
        },
        {
            label: 'Autocontroles',
            key: 'tab_4',
            children: <ContentAutocontroles result={result}></ContentAutocontroles>,
        },
        ...(añosFichasAnuales.length > 0 ? [{
            label: 'Fichas anuales',
            key: 'tab_5',
            children: <ContentFichasAnuales result={result} añosFichasAnuales={añosFichasAnuales}></ContentFichasAnuales>,
        }] : []),
    ];

    return (
        <>
            <Tabs
                defaultActiveKey="tab_1"
                items={tabItems}
            />
        </>
    )
}

const ContentDatosConstructivos = ({ result, edr }) => {
    //console.log("result", result)
    //console.log("edr", edr)
    let fechaSer = "";
    if (edr.datosContructivos.fechaSer != null && !Number.isNaN(edr.datosContructivos.fechaSer)) {
        fechaSer = new Date(edr.datosContructivos.fechaSer).toLocaleDateString();
    }

    const formatNumber = (num) => {
        if (num == null || num === undefined || num === "") {
            return "-";
        }
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    return (
        <Card>

            <Form
                layout="horizontal"
            >
                <Form.Item label="EDAR">
                    <Input value={result.feature.attributes.NOMBRE_EDA} />
                </Form.Item>
                <Form.Item label="Fecha Entrada Servicio">
                    <Input value={fechaSer} />
                </Form.Item>
                <Form.Item label="Destino Efluente">
                    <Input value={edr.datosContructivos.destinoEf} />
                </Form.Item>
                <Form.Item label="Tipo Tratamiento Agua">
                    <Input value={edr.datosContructivos.dtipoTagua} />
                </Form.Item>
                <Form.Item label="Coordenadas">
                    <Space.Compact>
                        <Form.Item>
                            <Input value={formatNumber(edr.datosContructivos.coordX ? Math.round(edr.datosContructivos.coordX) : "")} />
                        </Form.Item>
                        <Form.Item>
                            <Input value={formatNumber(edr.datosContructivos.coordY ? Math.round(edr.datosContructivos.coordY) : "")} />
                        </Form.Item>
                    </Space.Compact>
                </Form.Item>
            </Form>
            <Table dataSource={edr.datosNucleos} pagination={false} >
                <ColumnGroup title="Nucleos servidos">
                    <Column title="Código" dataIndex={["edrDatosWebNucleosPK", "codnucleo"]} key="codigo" />
                    <Column title="Nombre" dataIndex="nombreNucleo" key="nombre" />
                </ColumnGroup>
            </Table>
        </Card>
    )
}

const ContentDatosAnuales = ({ result, edr }) => {

    const formatNumber = (num) => {
        if (num == null || num === undefined || num === "") {
            return "-";


        }

        let numAux = num.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        return numAux.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };


    return (
        <>
            <Card>
                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >Año</Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={edr.datosContructivos.edrDatosWebPK.ano} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={edr.datosContructivos.edrDatosWebPK.ano ? edr.datosContructivos.edrDatosWebPK.ano - 1 : ''} />
                    </Col>
                    <Col span={6}>

                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >Media Caudal</Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosContructivos.caudalAvg)} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosAnterior.caudalAvg)} />
                    </Col>
                    <Col span={6}>
                        <div style={{ textAlign: "left", padding: "5px" }}>
                            <Text strong >m3/día</Text>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >Máximo mensual</Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosContructivos.heqMax)} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosAnterior.heqMax)} />
                    </Col>
                    <Col span={6}>
                        <div style={{ textAlign: "left", padding: "5px" }}>
                            <Text strong >Habitantes Equivalentes</Text>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >Datos Medios de Salida</Text>
                        </div>
                    </Col>
                    <Col span={6}>

                    </Col>
                    <Col span={6}>

                    </Col>
                    <Col span={6}>

                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >SS</Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosContructivos.ssSalAvg)} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosAnterior.ssSalAvg)} />
                    </Col>
                    <Col span={6}>
                        <div style={{ textAlign: "left", padding: "5px" }}>
                            <Text strong >mg/L</Text>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >DBO<sub>5</sub></Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosContructivos.dbo5SalAvg)} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosAnterior.dbo5SalAvg)} />
                    </Col>
                    <Col span={6}>
                        <div style={{ textAlign: "left", padding: "5px" }}>
                            <Text strong >mg/L</Text>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >DQO</Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosContructivos.dqoSalAvg)} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosAnterior.dqoSalAvg)} />
                    </Col>
                    <Col span={6}>
                        <div style={{ textAlign: "left", padding: "5px" }}>
                            <Text strong >mg/L</Text>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >Fango Total</Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosContructivos.fangoMfSum)} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosAnterior.fangoMfSum)} />
                    </Col>
                    <Col span={6}>
                        <div style={{ textAlign: "left", padding: "5px" }}>
                            <Text strong >Ton MF</Text>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={6}>
                        <div style={{ textAlign: "right", padding: "5px" }}>
                            <Text strong >Consumo Eléctrico Total</Text>
                        </div>
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosContructivos.consumoElecSum)} />
                    </Col>
                    <Col span={6}>
                        <Input style={{ textAlign: "center" }} value={formatNumber(edr.datosAnterior.consumoElecSum)} />
                    </Col>
                    <Col span={6}>
                        <div style={{ textAlign: "left", padding: "5px" }}>
                            <Text strong >Kwh</Text>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

const ContentFotos = ({ result, codedar }) => {

    const [edrFotos, setEdrFotos] = useState([]);

    //estado que controla la activacion o deszactivacion de la ventana modal Upload
    const [openModalUpload, setOpenModalUpload] = useState(false)

    //estado que controla la activacion o deszactivacion de la ventana modal Delete
    const [openModalDelete, setOpenModalDelete] = useState(false)

    const userstate = useSelector(user_state);

    //Esatado que sirve para controlar si todas las fotos se han cargado o no
    const [fotosCargadas, setFotosCargadas] = useState(false);

    const contentStyle = {
        margin: 0,
        color: '#fff',
        textAlign: 'center',
    };

    const styleSpinner = {
        padding: 50,
        display: "block",
    }

    const styleTitle = {
        color: 'black',
    }

    //Creacion del icono para el spinner
    const antIcon = <LoadingOutlined style={{ fontSize: 100 }} spin />;

    useEffect(() => {
        EdrService.listEdarFotos(codedar)
            .then((data) => {
                setEdrFotos(data.lists);
                setFotosCargadas(true)
            })
            .catch(err => {
                setFotosCargadas(false)
                if (err?.response?.json) {
                    err.response.json().then(res => {
                        console.log("ERROR", res);
                    }).catch(() => console.error(err));
                } else {
                    console.error(err);
                }
            })
    }, [])

    return (
        <>
            <Space>
                {userstate.token && userstate.authorities.includes("iaa") &&
                    <Button
                        type="primary"
                        onClick={(e) => { setOpenModalUpload(true); }}>
                        {i18next.t('common.tools.edit.upload-img')}
                        <UploadOutlined />
                    </Button>
                }

                {<ModalUpload open={openModalUpload} codedar={codedar} action={setOpenModalUpload} fotos={edrFotos} setFotos={setEdrFotos} />}
                {
                    userstate.token && userstate.authorities.includes("iaa") &&
                    <Button
                        type="primary"
                        onClick={(e) => { setOpenModalDelete(true); }}>
                        {i18next.t('common.tools.edit.delete-img')}
                        <DeleteOutlined />
                    </Button>
                }

                {<ModalDelete open={openModalDelete} action={setOpenModalDelete} fotos={edrFotos} setFotos={setEdrFotos} />}
            </Space>
            <div style={{
                display: 'block',
                padding: 10
            }}>

                {
                    fotosCargadas && <div style={{ backgroundColor: "lightgray" }}>
                        <Carousel>
                            {edrFotos.map((foto, i) => {
                                return <div id={foto.split(".")[0]} key={foto.split(".")[0]} >
                                    <div style={contentStyle}>
                                        {userstate.token && userstate.authorities.includes("iaa") &&
                                            <h3 style={styleTitle}>{"Foto " + (i + 1)}</h3>}
                                        <ContentFoto foto={foto} cargaFotos={setFotosCargadas}></ContentFoto>
                                    </div>
                                </div>
                            })}
                        </Carousel>
                    </div>
                }
                {
                    !fotosCargadas && <Spin indicator={antIcon} style={styleSpinner} />
                }
            </div>

        </>

    )
}

const ContentFoto = ({ foto, cargaFotos }) => {

    const [base64Foto, setBase64Foto] = useState();

    const contentStyle = {
        width: "400px",
        height: "auto",
        margin: 0,
        color: '#fff',
        textAlign: 'center',
    };

    useEffect(() => {
        EdrService.findEdarFoto(foto)
            .then((data) => {
                setBase64Foto(data.image);
            })
            .catch(err => {
                cargaFotos(false)
                if (err?.response?.json) {
                    err.response.json().then(res => {
                        console.log("ERROR", res);
                    }).catch(() => console.error(err));
                } else {
                    console.error(err);
                }
            })
    }, [foto])

    return (
        <Image
            src={base64Foto} style={contentStyle}
        />
    )
}

const ContentFichasAnuales = ({ result, añosFichasAnuales }) => {
    const codEdar = result.feature.attributes.CODEDAR;

    // Función para manejar el click en el enlace
    const handleDownload = (año) => {

        const hostname = window.location.hostname;

        let baseUrl;

        // Localhost
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            baseUrl = 'http://localhost:7001/edrw/api/reports/informe_anual';

            // PRE
        } else if (hostname.includes('preaplicaciones.aragon.es') || hostname.includes('preservicios.aragon.es')) {
            baseUrl = 'https://preaplicaciones.aragon.es/edrw/api/reports/informe_anual';

            // DESA
        } else if (hostname.includes('desaplicaciones.aragon.es') || hostname.includes('desservicios.aragon.es')) {
            baseUrl = 'https://desaplicaciones.aragon.es/edrw/api/reports/informe_anual';

            // PRO
        } else if (hostname.includes('aplicaciones.aragon.es') || hostname.includes('servicios.aragon.es')) {
            baseUrl = 'https://aplicaciones.aragon.es/edrw/api/reports/informe_anual';

            // Cualquier otro host inesperado
        } else {
            console.warn("Host no reconocido, usando PRO por defecto");
            baseUrl = 'https://aplicaciones.aragon.es/edrw/api/reports/informe_anual';
        }
      
        const url = `${baseUrl}/${año}/${codEdar}`;

        // Abrir la URL en una nueva ventana para descargar el PDF
        window.open(url, '_blank');
    };

    const años = añosFichasAnuales || [];

    return (
        <Card>
            {años.length > 0 ? (
                años.map((año) => (
                    <div key={año} style={{ padding: '4px 0', cursor: 'pointer' }}>
                        <span
                            onClick={(e) => {
                                e.preventDefault();
                                handleDownload(año);
                            }}
                            style={{
                                color: '#000',
                                fontSize: '14px'
                            }}
                        >
                            Informe anual de {año} &nbsp;
                            <Tooltip placement="right" title={"Descarga de informe"}>
                                <FilePdfOutlined
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(año);
                                    }}
                                />
                            </Tooltip>
                        </span>
                    </div>
                ))
            ) : (
                <Text>No hay datos anuales disponibles</Text>
            )}
        </Card>
    );
};

const ContentAutocontroles = ({ result }) => {

    const [treeData, setTreeData] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState();
    const [autocontroles, setAutocontroles] = useState();

    const download = (codEdar, year, trimestre) => {
        window.open(ServicesConfig.getAbsoluteUrl() + "/report/autocontroles/" + codEdar + "/" + year + "/" + trimestre)
    }

    useEffect(() => {
        var date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();

        let childrenCurrentYear = [{
            title: () => {
                return <>
                    Trimestre 1 &nbsp;
                    <Tooltip placement="right" title={"Descarga de informe"}>
                        <FilePdfOutlined onClick={(e) => {
                            e.stopPropagation();
                            download(result.feature.attributes.CODEDAR, year, 3);
                        }

                        } />
                    </Tooltip>
                </>
            },
            key: (year) + '-3',
            isLeaf: true,
        }];

        if (month > 2) {
            childrenCurrentYear.push({
                title: () => {
                    return <>
                        Trimestre 2 &nbsp;
                        <Tooltip placement="right" title={"Descarga de informe"}>
                            <FilePdfOutlined onClick={(e) => {
                                e.stopPropagation();
                                download(result.feature.attributes.CODEDAR, year, 6);
                            }

                            } />
                        </Tooltip>
                    </>
                },
                key: (year) + '-6',
                isLeaf: true,
            })
        }
        if (month > 5) {
            childrenCurrentYear.push({
                title: () => {
                    return <>
                        Trimestre 3 &nbsp;
                        <Tooltip placement="right" title={"Descarga de informe"}>
                            <FilePdfOutlined onClick={(e) => {
                                e.stopPropagation();
                                download(result.feature.attributes.CODEDAR, year, 9);
                            }

                            } />
                        </Tooltip>
                    </>
                },
                key: (year) + '-9',
                isLeaf: true,
            })
        }
        if (month > 8) {
            childrenCurrentYear.push({
                title: () => {
                    return <>
                        Trimestre 4 &nbsp;
                        <Tooltip placement="right" title={"Descarga de informe"}>
                            <FilePdfOutlined onClick={(e) => {
                                e.stopPropagation();
                                download(result.feature.attributes.CODEDAR, year, 12);
                            }

                            } />
                        </Tooltip>
                    </>
                },
                key: (year) + '-12',
                isLeaf: true,
            })
        }

        let data = [
            {
                title: "Datos autocontrol " + year,
                key: year,
                children: childrenCurrentYear,
            },
            {
                title: "Datos autocontrol " + (year - 1),
                key: year - 1,
                children: [
                    {
                        title: () => {
                            return <>
                                Trimestre 1 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 1), 3);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 1) + '-3',
                        isLeaf: true,
                    },
                    {
                        title: () => {
                            return <>
                                Trimestre 2 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 1), 6);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 1) + '-6',
                        isLeaf: true,
                    },
                    {
                        title: () => {
                            return <>
                                Trimestre 3 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 1), 9);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 1) + '-9',
                        isLeaf: true,
                    },
                    {
                        title: () => {
                            return <>
                                Trimestre 4 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 1), 12);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 1) + '-12',
                        isLeaf: true,
                    }
                ],
            },
            {
                title: "Datos autocontrol " + (year - 2),
                key: year - 2,
                expanded: true,
                children: [
                    {
                        title: () => {
                            return <>
                                Trimestre 1 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 2), 3);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 2) + '-3',
                        isLeaf: true,
                    },
                    {
                        title: () => {
                            return <>
                                Trimestre 2 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 2), 6);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 2) + '-6',
                        isLeaf: true,
                    },
                    {
                        title: () => {
                            return <>
                                Trimestre 3 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 2), 9);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 2) + '-9',
                        isLeaf: true,
                    },
                    {
                        title: () => {
                            return <>
                                Trimestre 4 &nbsp;
                                <Tooltip placement="right" title={"Descarga de informe"}>
                                    <FilePdfOutlined onClick={(e) => {
                                        e.stopPropagation();
                                        download(result.feature.attributes.CODEDAR, (year - 2), 12);
                                    }

                                    } />
                                </Tooltip>
                            </>
                        },
                        key: (year - 2) + '-12',
                        isLeaf: true,
                    }
                ],
            }
        ];

        setTreeData(data);
        setExpandedKeys([year, (year - 1), (year - 2)])
    }, []);


    const onExpand = (expandedKeysValue) => {
        setExpandedKeys(expandedKeysValue);
    };
    const onSelect = (keys, info) => {
        let year = keys[0].split("-")[0]
        let month = keys[0].split("-")[1]
        console.log('Trigger Select', keys, info);

        let autocontrolesCopy = {
            nomEDAR: result.feature.attributes.NOMBRE_EDA,
            codEDAR: result.feature.attributes.CODEDAR,
            year: year,
            month: month
        };

        setAutocontroles(autocontrolesCopy);
        console.log('autocontrolesCopy', autocontrolesCopy);

    };


    return (
        <>
            <DirectoryTree
                expandedKeys={expandedKeys}
                onExpand={onExpand}
                onSelect={onSelect}
                treeData={treeData}
            />
            {autocontroles && <VicaEDARAutocontroles
                setAutocontroles={setAutocontroles}
                nomEDAR={autocontroles.nomEDAR}
                codEDAR={autocontroles.codEDAR}
                year={autocontroles.year}
                month={autocontroles.month}></VicaEDARAutocontroles>}
        </>
    )
}